import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './TableList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';


const toBool = (v) => v === true || v === 1 || v === '1' || v === 'true';

export default function AdminClubAthletes() {
  const { id } = useParams(); // club_id din URL
  const navigate = useNavigate();
  const token = localStorage.getItem('adminToken');
  const [clubName, setClubName] = useState("");
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [searchTerm, setSearchTerm] = useState('');

  // modale
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [newAthlete, setNewAthlete] = useState({
    first_name: '',
    last_name: '',
    birth_year: '',
    cnp: '',
    email: '',
    phone: '',
    nr_legitimatie: ''
  });

  useEffect(() => {
    const fetchClubName = async () => {
      try {
        const res = await fetch(`https://www.fro.ro/api/admins/get-club.php?id=${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` },
        });
        const data = await res.json();
        if (data.success) setClubName(data.club.name);
      } catch {
        setClubName("(club necunoscut)");
      }
    };

    fetchClubName();
  }, [id]);

  const [editAthlete, setEditAthlete] = useState(null);

  /* =====================================================
     🔹 Fetch lista sportivilor
  ===================================================== */
  const fetchAthletes = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `https://www.fro.ro/api/athletes/index.php?club_id=${id}&year=${selectedYear}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await res.json();

      if (data.success) {
        setAthletes(data.data || []);
        setError(null);
      } else {
        setError(data.message || 'Eroare la încărcarea sportivilor');
      }
    } catch (err) {
      setError('Eroare conexiune: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAthletes();
  }, [id, selectedYear]);

  /* =====================================================
     🔹 Legitimare (activare) sportiv
  ===================================================== */
  const handleLegitimare = async (athlete) => {
    const confirm = window.confirm(
      `Sigur vrei să legitimezi sportivul ${athlete.first_name} ${athlete.last_name} pentru anul ${selectedYear}?`
    );
    if (!confirm) return;

    try {
      const res = await fetch('https://www.fro.ro/api/athletes/legitimeaza-sportiv.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          athlete_id: athlete.id,
          club_id: id,
          year: selectedYear,
        }),
      });

      const data = await res.json();
      if (data.success) {
        alert(`Legitimare efectuată. Taxa: ${data.taxa} lei.`);
        fetchAthletes();
      } else {
        alert(data.message || 'Eroare la legitimare.');
      }
    } catch (err) {
      alert('Eroare conexiune: ' + err.message);
    }
  };

  /* =====================================================
     🔹 Ștergere sportiv
  ===================================================== */
  const handleDelete = async (athleteId) => {
    if (!window.confirm('Sigur dorești să ștergi acest sportiv?')) return;

    try {
      const res = await fetch(
        `https://www.fro.ro/api/athletes/delete.php?id=${athleteId}`,
        {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await res.json();

      if (data.success) {
        alert('Sportiv șters.');
        fetchAthletes();
      } else {
        alert(data.message || 'Eroare la ștergere.');
      }
    } catch (err) {
      alert('Eroare la conexiune: ' + err.message);
    }
  };

  /* =====================================================
     🔹 Adăugare sportiv
  ===================================================== */
  const handleAddAthlete = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://www.fro.ro/api/athletes/create.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ...newAthlete, club_id: id }),
      });

      const data = await res.json();
      if (data.success) {
        alert('Sportiv adăugat cu succes!');
        setShowAddModal(false);
        setNewAthlete({
          first_name: '',
          last_name: '',
          birth_year: '',
          cnp: '',
          email: '',
          phone: '',
          nr_legitimatie: '',
        });
        fetchAthletes();
      } else {
        alert(data.message || 'Eroare la adăugare.');
      }
    } catch (err) {
      alert('Eroare la conexiune: ' + err.message);
    }
  };

  /* =====================================================
     🔹 Editare sportiv
  ===================================================== */
  const handleEditAthlete = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('https://www.fro.ro/api/athletes/edit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editAthlete),
      });

      const data = await res.json();
      if (data.success) {
        alert('Sportiv actualizat cu succes!');
        setShowEditModal(false);
        setEditAthlete(null);
        fetchAthletes();
      } else {
        alert(data.message || 'Eroare la actualizare.');
      }
    } catch (err) {
      alert('Eroare la conexiune: ' + err.message);
    }
  };

  /* =====================================================
     🔹 Filtrare sportivi
  ===================================================== */
  const filteredAthletes = athletes.filter((a) =>
    `${a.first_name} ${a.last_name}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /* =====================================================
     🔹 UI
  ===================================================== */
  if (loading) return <p>Se încarcă sportivii...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div className="table-list-container">
      <div className="table-list-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ⬅Înapoi
        </button>

        <select

          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          className="year-dropdown"
        >
          {[new Date().getFullYear(), new Date().getFullYear() + 1].map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
        <h1>Sportivi – {clubName ? clubName : `Club #${id}`}</h1>


        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>



          <input
            type="text"
            placeholder="Caută sportiv..."
            className="search-bar"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <button
            className="add-circle-btn"
            onClick={() => setShowAddModal(true)}
            aria-label="Adaugă sportiv"
          >
            <span className="plus-icon">+</span>
          </button>
        </div>
      </div>

      <table className="table-list">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nume</th>
            <th>An naștere</th>
            <th>CNP</th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Activat</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {filteredAthletes.length === 0 ? (
            <tr><td colSpan={8}>Nu există sportivi.</td></tr>
          ) : (
            filteredAthletes.map((a) => (
              <tr key={a.id} className={toBool(a.is_legitimated) ? 'active-row' : ''}>
                <td>{a.id}</td>
                <td>{a.first_name} {a.last_name}</td>
                <td>{a.birth_year}</td>
                <td>{a.cnp}</td>
                <td>{a.email || '-'}</td>
                <td>{a.phone || '-'}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={toBool(a.is_legitimated)}
                    disabled={toBool(a.is_legitimated)}
                    onChange={() => handleLegitimare(a)}
                  />
                </td>
                <td className="table-list-actions">
                  <button className="action-btn edit" onClick={() => { setEditAthlete(a); setShowEditModal(true); }}>
                    <FontAwesomeIcon icon={faPen} />
                  </button>
                  <button className="action-btn delete" onClick={() => handleDelete(a.id)}>
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </td>

              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* 🔹 Modal adăugare sportiv */}
      {showAddModal && (
        <div className="modal-backdrop" onClick={() => setShowAddModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Adaugă sportiv</h3>
            <form onSubmit={handleAddAthlete} className="modal-form">
              <label>Prenume</label>
              <input type="text" value={newAthlete.first_name} onChange={(e) => setNewAthlete({ ...newAthlete, first_name: e.target.value })} required />
              <label>Nume</label>
              <input type="text" value={newAthlete.last_name} onChange={(e) => setNewAthlete({ ...newAthlete, last_name: e.target.value })} required />
              <label>An naștere</label>
              <input type="number" value={newAthlete.birth_year} onChange={(e) => setNewAthlete({ ...newAthlete, birth_year: e.target.value })} required />
              <label>CNP</label>
              <input type="text" value={newAthlete.cnp} onChange={(e) => setNewAthlete({ ...newAthlete, cnp: e.target.value })} required />
              <label>Email</label>
              <input type="email" value={newAthlete.email} onChange={(e) => setNewAthlete({ ...newAthlete, email: e.target.value })} />
              <label>Telefon</label>
              <input type="text" value={newAthlete.phone} onChange={(e) => setNewAthlete({ ...newAthlete, phone: e.target.value })} />
              <div className="modal-actions">
                <button type="submit" className="save-btn">Salvează</button>
                <button type="button" className="cancel-btn" onClick={() => setShowAddModal(false)}>Anulează</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* 🔹 Modal editare sportiv */}
      {showEditModal && editAthlete && (
        <div className="modal-backdrop" onClick={() => setShowEditModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Editează sportiv</h3>
            <form onSubmit={handleEditAthlete} className="modal-form">
              <label>Prenume</label>
              <input type="text" value={editAthlete.first_name} onChange={(e) => setEditAthlete({ ...editAthlete, first_name: e.target.value })} required />
              <label>Nume</label>
              <input type="text" value={editAthlete.last_name} onChange={(e) => setEditAthlete({ ...editAthlete, last_name: e.target.value })} required />
              <label>An naștere</label>
              <input type="number" value={editAthlete.birth_year} onChange={(e) => setEditAthlete({ ...editAthlete, birth_year: e.target.value })} required />
              <label>CNP</label>
              <input type="text" value={editAthlete.cnp} onChange={(e) => setEditAthlete({ ...editAthlete, cnp: e.target.value })} required />
              <label>Email</label>
              <input type="email" value={editAthlete.email} onChange={(e) => setEditAthlete({ ...editAthlete, email: e.target.value })} />
              <label>Telefon</label>
              <input type="text" value={editAthlete.phone} onChange={(e) => setEditAthlete({ ...editAthlete, phone: e.target.value })} />
              <label>Nr. legitimație</label>
              <input type="text" value={editAthlete.nr_legitimatie || ''} onChange={(e) => setEditAthlete({ ...editAthlete, nr_legitimatie: e.target.value })} />
              <div className="modal-actions">
                <button type="submit" className="save-btn">Actualizează</button>
                <button type="button" className="cancel-btn" onClick={() => setShowEditModal(false)}>Anulează</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
